// ==== FOOTER: Track MW non-case related Forms ==== //

;(function($){
  // Global namespace
  var fxFormsTrack  = fxFormsTrack || {};

  // Global variables
  var $document     = $(document);

  $(function(){
    fxFormsTrack.init = function(parent, children) {

      $document.on('forminator:form:submit:success', function(formData) {
        var form_id = $(formData.target).find('input[name="hidden-1"]').val();

        if (form_id == 'book-valuation') {
          // LinkedIn conversions
          var imgtag = new Image(1, 1);
          imgtag.src = "https://px.ads.linkedin.com/collect/?pid=1585393&conversionId=1929794&fmt=gif";

          // Google conversions
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              'event': 'formSubmitted',
              'formID': form_id
            });
          }

          // Facebook conversions
          if (typeof window['fbq'] == 'function') {
            setTimeout(function() {
              fbq('track', 'Lead', {formID: form_id});
            }, 2000);
          }
        } else if (typeof form_id === 'undefined') {
          form_id = $(formData.target).attr('data-form-id');

          // Google conversions
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push({
              'event': 'formSubmitted',
              'formID': form_id
            });
          }

          // Facebook conversions
          if (typeof window['fbq'] == 'function') {
            setTimeout(function() {
              fbq('track', 'Lead', {formID: form_id});
            }, 2000);
          }
        }
      });
    }

    fxFormsTrack.init();
  });

}(jQuery));
